<!--
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-10-11 16:54:09
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-10 11:06:38
-->
<template>
  <a-modal
    v-model:visible="visible"
    class="dynamic-form-modal"
    :title="title"
    :width="width"
    :mask-closable="false"
    destroy-on-close
    @cancel="handleCancel"
  >
    <template #closeIcon>
      <svg-icon class="icon translate-c" name="icon-close" />
    </template>
    <a-form
      ref="formRef"
      label-align="left"
      :model="dynamicValidateForm"
      v-bind="formItemLayoutWithOutLabel"
      class="cr-form"
    >
      <slot></slot>
      <div
        v-for="(formDataItem, index) in dynamicValidateForm.formData"
        :key="formDataItem.key"
        class="cus-form-item"
      >
        <a-form-item
          v-if="!formDataItem.isHide"
          v-bind="formItemLayout"
          :name="['formData', index, 'value']"
          :rules="formDataItem.rules"
          :colon="false"
        >
          <template #label>
            <span v-if="formDataItem.label" class="cus-form-label">
              {{ formDataItem.label }}

              <a-tooltip
                v-if="formDataItem.showTip"
                placement="top"
                color="#fff"
                overlay-class-name="cus-tooltip-card"
              >
                <template #title>
                  <span>{{ formDataItem.tipInfo }}</span>
                </template>
                <svg-icon
                  name="icon-info-fill"
                  color="#B4B8BF"
                  style="width: 12px; height: 12px"
                ></svg-icon>
              </a-tooltip>
            </span>
          </template>
          <!-- input -->
          <a-input
            v-if="formDataItem.type === 'input'"
            v-model:value="formDataItem.value"
            size="large"
            :placeholder="formDataItem.placeholder"
            :disabled="formDataItem.disabled"
          />
          <!-- password -->
          <a-input-password
            v-if="formDataItem.type === 'password'"
            v-model:value="formDataItem.value"
            :placeholder="formDataItem.placeholder"
            :disabled="formDataItem.disabled"
            size="large"
          />
          <!-- text -->
          <span v-if="formDataItem.type === 'text'">{{ formDataItem.value }}</span>

          <!-- 多选select tag -->
          <SelectTags
            v-if="formDataItem.type === 'multipleSelectEmpty'"
            :form-data-item="formDataItem"
            @focus="formDataItem.focus"
          />

          <!-- treeSelect -->
          <a-tree-select
            v-if="formDataItem.type === 'treeSelect'"
            v-model:value="formDataItem.value"
            v-model:tree-expanded-keys="formDataItem.treeExpandedKeys"
            style="width: 100%"
            :show-search="false"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto', maxWidth: '300px' }"
            :replace-fields="formDataItem.replaceFields"
            :tree-data="formDataItem.data"
            :filter-tree-node="filterTreeNode"
            :tree-checkable="!!formDataItem.treeCheckable"
            :allow-clear="false"
            :placeholder="formDataItem.placeholder"
            @select="formDataItem.select"
          >
            <!-- <template #title="{ key, value }">
              <a-tooltip v-if="getTreeIsShowMore(node, formDataItem.replaceFields)">
                <template #title>
                  {{ 88 }}
                </template>
                <div class="title overfl-oneline">
                  {{ 88 }}
                </div>
              </a-tooltip>
              <div v-else class="title">
                {{ 88 + '-999' }}
              </div>
            </template>-->
          </a-tree-select>

          <a-select
            v-if="formDataItem.type === 'select'"
            v-model:value="formDataItem.value"
            @change="formDataItem.select"
          >
            <a-select-option v-for="item in formDataItem.data" :key="item.jdyId" :value="item">
              {{ item.algorithmTaskId }}--{{ item.originCnName }}
            </a-select-option>
          </a-select>

          <!-- radio -->
          <a-radio-group
            v-if="formDataItem.type === 'radio'"
            v-model:value="formDataItem.value"
            name="radioGroup"
            @change="formDataItem.change"
          >
            <a-radio v-for="radio in formDataItem.data" :key="radio.value" :value="radio.value">{{
              radio.label
            }}</a-radio>
          </a-radio-group>

          <div v-if="formDataItem.bottomTip" class="bottom-tip">{{ formDataItem.bottomTip }}</div>
        </a-form-item>
        <slot name="cusContent"></slot>
      </div>
    </a-form>
    <slot name="cusAction"></slot>

    <template #footer>
      <a-button key="back" @click="handleCancel">{{ cancelText }}</a-button>
      <a-button key="submit" html-type="submit" type="primary" :loading="loading" @click="handleOk"
        >{{ okText }}
      </a-button>
    </template>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, ref, toRefs, UnwrapRef, reactive, toRaw } from 'vue'
import { ValidateErrorEntity } from 'ant-design-vue/es/form/interface'
import SelectTags from '../SelectTags/index.vue'

export default defineComponent({
  components: {
    SelectTags
  },
  props: {
    width: {
      type: [String, Number],
      default: 500
    },
    title: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    submit: {
      type: Function,
      default: () => {}
    },
    cancel: {
      type: Function,
      default: () => {}
    },
    roleColors: {
      type: Array,
      default: () => []
    },
    faceColors: {
      type: Array,
      default: () => []
    },
    faceLableColors: {
      type: Array,
      default: () => []
    },
    formItemLayout: {
      type: Object,
      default: () => ({
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      })
    }
  },
  setup(props) {
    // 表单
    const formRef = ref()
    const formItemLayoutWithOutLabel = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 20, offset: 4 }
      }
    }
    const dynamicValidateForm: UnwrapRef<{ formData: any[] }> = reactive({
      formData: []
    })
    const submitForm = () => {}
    const resetForm = () => {
      formRef.value.resetFields()
    }

    const clearValidate = () => {
      formRef.value.clearValidate()
    }

    const loading = ref<boolean>(false)
    const visible = ref<boolean>(false)
    const { submit, cancel } = toRefs(props)

    const showModal = (formData) => {
      visible.value = true
      dynamicValidateForm.formData = formData
    }

    const closeModal = () => {
      visible.value = false
    }

    const handleOk = () => {
      const formData = toRaw(dynamicValidateForm.formData)
      formRef.value
        .validate()
        .then(async () => {
          const formData = toRaw(dynamicValidateForm.formData)
          const data: any = {}
          formData.forEach((item: any) => {
            if (!item.isHide) {
              data[item.submitName] = item[item.submitValueKey ? item.submitValueKey : 'value']
            }
          })

          loading.value = true
          const res: any = await submit.value(data)
          loading.value = false

          if (res) {
            visible.value = false
          }
        })
        .catch((error: ValidateErrorEntity<any>) => {
          console.log('error', error)
        })
    }

    const handleCancel = () => {
      resetForm()
      visible.value = false
      cancel.value && cancel.value()
    }

    // 计算树形控件宽度
    const getTreeIsShowMore = (node: any, replaceFields: any) => {
      const res: boolean = node[replaceFields.title].length > 15
      return res
    }

    // 设置树形结构自定义template
    const setTreeSelectTemplate = (treeData: any[], titleKey: string) => {
      const loopData = (list: any[]) => {
        list.forEach((item: any) => {
          item.slots = {
            title: titleKey
          }

          if (item.children && item.children.length) {
            loopData(item.children)
          }
        })
      }

      loopData(treeData)

      return treeData
    }

    const filterTreeNode = (inputValue: string, treeNode) => {
      return treeNode.props.title.includes(inputValue)
    }

    const showLoading = (isShow: boolean) => {
      loading.value = isShow
    }

    return {
      loading,
      visible,
      showModal,
      handleOk,
      handleCancel,
      dynamicValidateForm,
      formItemLayoutWithOutLabel,
      submitForm,
      resetForm,
      formRef,
      getTreeIsShowMore,
      setTreeSelectTemplate,
      filterTreeNode,
      clearValidate,
      showLoading,
      closeModal
    }
  }
})
</script>

<style lang="less">
.dynamic-form-modal {
  .ant-input {
    width: 100%;
  }

  .cus-form-item {
    margin-bottom: 5px;
  }

  .tag-select.ant-select-multiple {
    .ant-select-selection-item {
      border: none;
      background: none;
      margin-inline-end: 0;
      padding-inline-start: 0;
      padding-inline-end: 0;
      margin-right: 1px;

      &:first-of-type {
        margin-left: 3px;
      }

      .anticon-close {
        display: none;
      }
    }
  }

  .tag-container {
    margin-right: 0;
  }

  .ant-select-multiple.ant-select-lg .ant-select-selection-item,
  .ant-select-multiple.ant-select-lg .ant-select-selection-search,
  .ant-select-multiple.ant-select-lg .ant-select-selection-search-input,
  .ant-select-multiple.ant-select-lg .ant-select-selection-search-mirror {
    height: 20px;
    line-height: 20px;
  }

  .cus-form-label {
    display: flex;
    align-items: center;
  }
}
</style>
